export default function($) {
  var nav = $('#product-nav')
  if (nav.length <= 0) {
    return
  }
  var navOffset = nav.offset()

  $(window).scroll(function() {
    if( $(window).width() >= 1024 ) {
      if ($(this).scrollTop() >= navOffset.top) {
        $('.js-quick-nav').fadeIn();
        if( $('body').hasClass('admin-bar') ) {
          $('.js-quick-nav').css('top', '32px');
        } else {
          $('.js-quick-nav').css('top', '0');
        }
      } else {
        $('.js-quick-nav').fadeOut();
      }
    }
  });

}
